import React from 'react';

import {CustomInputSearch} from './customInputSearch.style.js';

export default function (props) {

    const [showList, setShowList] = React.useState(true);
    const [searchTerm, setSearchTerm] = React.useState((typeof props.inputSearchString !== 'undefined') ? props?.inputSearchString : '');
    const [searchResults, setSearchResults] = React.useState([]);

    const handleChange = e => {
        setSearchTerm(e.target.value);
    };

    const onSelect = item => {
        setSearchTerm(item.label);
        props.onSelect(item);
        setShowList(false);
    };
    
    React.useEffect(() => {
        if(searchTerm.length >= 3 && showList) {
            let searchTermNormalized = searchTerm.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            const results = props.items.filter(item =>
                item.normalized.includes(searchTermNormalized)
            )
            setSearchResults(results);
        }
        else {
            setShowList(true);
            setSearchResults([]);
        }
    }, [searchTerm]);

    return (
        <CustomInputSearch>
            <input
                { ...(props?.autoFocus) ? 'autoFocus' : '' } 
                type="text"
                value={searchTerm}
                className='ant-input'
                onChange={handleChange}
                placeholder={props.placeholder}
            />
            {
                (searchTerm.length !== 0) ?
                    <ul>
                        {searchResults.map(item => (
                            <li onClick={(evt)=>onSelect(item)}>{item.label}</li>
                        ))}
                    </ul>
                : ''
            }
        </CustomInputSearch>
    );
}